import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AccountInfoContainer = styled.div<React.CSSProperties>`
  margin-top: ${50 * Screen.widthRatio}px;
  margin-bottom: ${50 * Screen.widthRatio}px;
`;

export default AccountInfoContainer;
